import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

import React from 'react';

export const DEFAULT_PLACEHOLDER = 'Search...';

export type TSearchInputProps = {
  value: string;
  placeholder?: string;
  onTextChange: (text: string) => void;
} & Omit<TextFieldProps, 'value' | 'onChange' | 'placeholder'>;

export default function SearchInput({
  value,
  placeholder,
  onTextChange,
  ...props
}: TSearchInputProps) {
  const placeholderText = placeholder ?? DEFAULT_PLACEHOLDER;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onTextChange(e.target.value);
  };

  return (
    <TextField
      {...props}
      value={value}
      onChange={handleChange}
      placeholder={placeholderText}
      data-component="SearchTextInput"
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}
